import { Button, Popconfirm, Popover, Tooltip } from 'antd';
import EditIcon from '../../../common/icons/EditIcon';
import DeleteIcon from '../../../common/icons/DeleteIcon';
import successNotification from '../../../utils/successNotification';
import errorNotification from '../../../utils/errorNotification';
import deletePayment from '../../../apis/pos-api/cash-payments/deletePayment';
import { EyeOutlined, PrinterOutlined } from '@ant-design/icons';
import deletePaymentProducts from '../../../apis/cash-payments-products/deletePaymentProducts';

const tableColumns = (
  allFetchedCashOut,
  setSelectedCash,
  setIsLoading,
  setModalOpenedCashIn,
  setFetchCount,
  setModalOpened,
  printModalCash,
  setPrintModalCash,
  t,
  token
) => {
  const handleViewReceiptClick = (record) => {
    const foundInvoice = allFetchedCashOut.find(
      (receipt) => receipt.id === record.id
    );
    if (foundInvoice) {
      setSelectedCash({ ...foundInvoice });
      setPrintModalCash(true);
    }
  };

  // const handleViewReceiptClick = (record) => {
  //   const foundInvoice = allFetchedSaleInvoices.find(
  //     (receipt) => receipt.id === record.id
  //   );
  //   if (foundInvoice) {
  //     setSelectedInvoice({ ...foundInvoice });
  //     setSelectedSaleInvoiceModalOpened(true);
  //   }
  // };

  // const handleReturnClick = (record) => {
  //   const foundInvoice = allFetchedSaleInvoices.find(
  //     (receipt) => receipt.id === record.id
  //   );
  //   if (foundInvoice) {
  //     setSelectedInvoice({ ...foundInvoice });
  //     setReturnModalOpened(true);
  //   }
  // };

  // const renderActions = (record) => {
  //   if (record?.is_return === 0) {
  //     if (parseFloat(record?.totalPrice) == 0) {
  //       return (
  //         <div
  //           className="edit-btn"
  //           style={{
  //             opacity: '.6',
  //             cursor: 'not-allowed'
  //           }}
  //         >
  //           <EditIcon />
  //           طلب ارتجاع
  //         </div>
  //       );
  //     }
  //     return (
  //       <div className="edit-btn" onClick={() => handleReturnClick(record)}>
  //         <EditIcon />
  //         طلب ارتجاع
  //       </div>
  //     );
  //   } else {
  //     return 'تم ارتجاع الفاتورة';
  //   }
  // };

  const handleEditProduct = (record) => {
    const found = allFetchedCashOut.find((place) => place.id === record.id);
    if (found) {
      setSelectedCash({ ...found });
      setModalOpened(true);
    }
  };

  const handleDeleteRequest = async (id) => {
    try {
      setIsLoading(true);
      const res = await deletePaymentProducts(token, id);
      if (res?.status === 200 && res?.data?.status === 1) {
        setIsLoading(false);
        setFetchCount((prevState) => prevState + 1);
        successNotification({
          title: t('Inventory.CashOut.addedSuccessfully'),
          message: t('Inventory.CashOut.cashOutSuccessfullyDeleted')
        });
      } else {
        setIsLoading(false);
        errorNotification({
          title: t('Inventory.CashOut.errorOccurredDuringOperation'),
          message: res?.data?.message
            ? res.data.message
            : t('Inventory.CashOut.pleaseTryLater')
        });
      }
    } catch (error) {
      setIsLoading(false);
      errorNotification({
        title: t('Inventory.CashOut.errorOccurred'),
        message: t('Inventory.CashOut.pleaseTryLater')
      });
    }
  };

  // const handleViewReceiptClick = (record) => {
  //   const foundInvoice = allFetchedSaleInvoices.find(
  //     (receipt) => receipt.id === record.id
  //   );
  //   if (foundInvoice) {
  //     setSelectedInvoice({ ...foundInvoice });
  //     setSelectedSaleInvoiceModalOpened(true);
  //   }
  // };

  const renderActions = (record) => {
    return (
      <div className="action-btns-wrap">
        <div className="edit-btn" onClick={() => handleEditProduct(record)}>
          <EditIcon />
          {t('Inventory.CashOut.edit')}
        </div>
        <Popconfirm
          title={t('Inventory.CashOut.areyouSureToDelete')}
          onConfirm={() => handleDeleteRequest(record.id)}
          okText={t('Inventory.CashOut.yes')}
          cancelText={t('Inventory.CashOut.no')}
        >
          <Tooltip title={t('Inventory.CashOut.delete')}>
            <div className="delete-btn">
              <DeleteIcon />
            </div>
          </Tooltip>
        </Popconfirm>
      </div>
    );
  };

  return [
    {
      title: t('Inventory.CashOut.serialNumber'),
      dataIndex: 'id',
      // width: 62
      render: (_, record) => {
        return (
          <div className="row-cell row-index bold-font">
            <span>{record.id}</span>
          </div>
        );
      }
    },

    {
      title: t('Inventory.CashOut.section'),
      dataIndex: 'department',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">{record?.department?.name}</div>
        );
      }
    },
    {
      title: t('Inventory.CashOut.name'),
      dataIndex: 'username_reciept',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">{record?.username_reciept}</div>
        );
      }
    },
    {
      title: t('Inventory.CashOut.tableAmount'),
      dataIndex: 'amount',
      render: (_, record) => {
        return <div className="row-cell row-text">{record.amount}</div>;
      }
    },

    {
      title: t('Inventory.CashOut.note'),
      dataIndex: 'title',
      render: (_, record) => {
        return <div className="row-cell row-text">{record.title}</div>;
      }
    },

    {
      title: t('Inventory.CashOut.tableDueDate'),
      dataIndex: 'date',
      render: (_, record) => {
        return (
          <div className="row-cell row-text">
            {record?.date ? record.date : '----'}
          </div>
        );
      }
    },
    {
      title: t('Inventory.CashOut.invoicePreview'),
      render: (_, record) => {
        return (
          <div className="row-cell row-circled-btn">
            <Tooltip title={t('Inventory.CashOut.invoicePreview')}>
              <Button
                className="circled-btn"
                type="dashed"
                shape="circle"
                icon={<EyeOutlined />}
                onClick={() => handleViewReceiptClick(record)}
              />
            </Tooltip>
          </div>
        );
      }
    },
    {
      title: t('Inventory.CashOut.settings'),
      dataIndex: 'actions',
      render: (_, record) => {
        return (
          <div className="row-cell row-actions">{renderActions(record)}</div>
        );
      }
    }

    // {
    //   title: 'معاينة الفاتورة',
    //   render: (_, record) => {
    //     return (
    //       <div className="row-cell row-circled-btn">
    //         <Tooltip title="معاينة الفاتورة">
    //           <Button
    //             className="circled-btn"
    //             type="dashed"
    //             shape="circle"
    //             icon={<EyeOutlined />}
    //             onClick={() => handleViewReceiptClick(record)}
    //           />
    //         </Tooltip>
    //       </div>
    //     );
    //   }
    // },
  ];
};

export default tableColumns;
